<template>
  <div class="c-map-search__wrapper">
    <div
      class="c-map-search"
      v-for="search in getPostcodeSearch"
      :key="search.index"
    >
      <label class="c-map-search__label" :for="id">
        {{ search.postcodeSearchDesktopLabel }}
      </label>
      <div class="c-map-search__search">
        <input
          :id="id"
          class="controls c-map-search__input pac-input"
          type="search"
          :placeholder="search.placeholderText"
          role="searchbox"
        />

        <button class="c-map-search__button" v-on:click="onSearch" aria-label="Search location">
          <svg aria-hidden="true" focusable="false">
            <use
              xmlns:xlink="http://www.w3.org/1999/xlink"
              xlink:href="#search-alt"
            />
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MapSearch",
  props: ["config", "id", "map"],
  data() {
    return {
      searchBox: null,
    };
  },
  mounted() {
    if (this.map) {
      this.initSearch();
    }
  },
  computed: {
    getPostcodeSearch: function () {
      if (this.config) {
        return this.config.buttons.filter(
          (button) => button.buttonType === "PostcodeSearch"
        );
      }
    },
  },
  methods: {
    onSearch() {
      const input = document.getElementById(this.id);
      google.maps.event.trigger(input, "focus", {});
      google.maps.event.trigger(input, "keydown", { keyCode: 13 });
      this.$emit("searchLocation");
    },
    initSearch() {
      const input = document.getElementById(this.id);
      this.searchBox = new google.maps.places.SearchBox(input);

      this.map.addListener("bounds_changed", () => {
        this.searchBox.setBounds(this.map.getBounds());
      });

      this.searchBox.addListener("places_changed", () => {
        const places = this.searchBox.getPlaces();

        if (!places) {
          return;
        }

        const bounds = new google.maps.LatLngBounds();
        places.forEach((place) => {
          if (!place.geometry || !place.geometry.location) {
            return;
          }

          if (place.geometry.viewport) {
            bounds.union(place.geometry.viewport);
          } else {
            bounds.extend(place.geometry.location);
          }
        });
        this.map.fitBounds(bounds);
        this.$emit("searchLocation");
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/components/consumer/layered-map/MapSearch.vue